import { gql } from '@apollo/client'

export const Query = gql`
  query EditClient($companyId: ID!, $filters: ClientFilters) {
    clients(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        organisationName
        address1
        address2
        address3
        city
        county
        postcode
        clientType { id }
        phone
        email
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }

`
